module.exports = __webpack_public_path__ + "static/chp-video-23fa2e2ca384d51863d4233832e9c9a2.mp4";